export const USER = 'user'
export const BRANDID = 'brandId'
export const CLIENTID = 'clientId'
